import styled from 'styled-components';
import { DIMENSIONS } from 'utils/constants';

export const TileContainer = styled.div`
  padding-bottom: ${(props: { lastTile: boolean }) => (!props.lastTile ? '20px' : '0px')};
  @media screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding-bottom: ${(props: { lastTile: boolean }) => (!props.lastTile ? '10px' : '40px')};
  }
`;
